module.exports = __webpack_public_path__ + "static/media/neutral_placeholder.b6681619.png";